import VideoCarouselCard from "./VideoCarouselCard";

export default VideoCarouselCard;